import { render } from "./ListagemOsTablets.vue?vue&type=template&id=3b1654a5&scoped=true"
import script from "./ListagemOsTablets.vue?vue&type=script&lang=js"
export * from "./ListagemOsTablets.vue?vue&type=script&lang=js"

import "./ListagemOsTablets.vue?vue&type=style&index=0&id=3b1654a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1654a5"]])

export default __exports__